/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(shown in amber) is the predicted fantasy points for the upcoming race. After the race, this switches to actual points scored.`)
};

const es_f1_apex_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(en ámbar) son los puntos fantasy predichos para la próxima carrera. Después de la carrera, esto cambia a los puntos reales obtenidos.`)
};

const de_f1_apex_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(in Amber angezeigt) sind die vorhergesagten Fantasy-Punkte für das kommende Rennen. Nach dem Rennen werden die tatsächlichen Punkte angezeigt.`)
};

const nl_f1_apex_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(in amber) zijn de voorspelde fantasypunten voor de komende race. Na de race schakelt dit over naar de werkelijk behaalde punten.`)
};

const fr_f1_apex_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(en ambre) représente les points fantasy prédits pour la prochaine course. Après la course, cela bascule vers les points réels marqués.`)
};

const it_f1_apex_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(in ambra) sono i punti fantasy previsti per la prossima gara. Dopo la gara, questo mostra i punti effettivi ottenuti.`)
};

const pt_br2_f1_apex_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(em âmbar) são os pontos fantasy previstos para a próxima corrida. Depois da corrida, isso muda para os pontos reais marcados.`)
};

const pt_f1_apex_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(em âmbar) são os pontos fantasy previstos para a próxima corrida. Após a corrida, isto muda para os pontos reais obtidos.`)
};

const ja_f1_apex_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（アンバーで表示）は次のレースの予測ファンタジーポイントです。レース後は実際のポイントに切り替わります。`)
};

const zh_f1_apex_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（琥珀色显示）是即将到来的比赛的预测幻想积分。赛后会切换为实际得分。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_how_p3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_how_p3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_how_p3", locale)
	if (locale === "en") return en_f1_apex_how_p3(inputs)
	if (locale === "es") return es_f1_apex_how_p3(inputs)
	if (locale === "de") return de_f1_apex_how_p3(inputs)
	if (locale === "nl") return nl_f1_apex_how_p3(inputs)
	if (locale === "fr") return fr_f1_apex_how_p3(inputs)
	if (locale === "it") return it_f1_apex_how_p3(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_how_p3(inputs)
	if (locale === "pt") return pt_f1_apex_how_p3(inputs)
	if (locale === "ja") return ja_f1_apex_how_p3(inputs)
	return zh_f1_apex_how_p3(inputs)
};